/* ALPINULIN · Aktionscode aus dem Countdown-Banner (z. B. „20 % mit WEEK20“)
   - Produktseite: „Mit Code WEEK20: 43,92 €“ + Button „Code anwenden“
   - Warenkorb: Button „WEEK20 einlösen“, solange kein Code im Warenkorb steckt
   - Geschenk-Staffel (data-alpl-gifts, z. B. „100:Gummies,170:Sleep Spray,250:Soaring Stream#4711“): Fortschritt
     im Warenkorb, Hinweis auf der Produktseite. Beilegen tut EasyGift; Stufen mit „#Varianten-ID“ legt dieses
     Skript selbst bei bzw. nimmt sie wieder heraus (EasyGift-Standardplan hat nur 3 Regeln).
     Stufen mit „%“ im Namen (z. B. „300:40 %“) sind Rabattstufen: gleicher Balken, Text „Noch … bis 40 %“.
   Code, Prozent und Ende kommen aus blocks/_announcement-countdown.liquid (data-alpl-promo*).
   Nach Ablauf rendert das Banner nichts mehr, dann bleibt auch hier alles aus. */
(() => {
  const banner = document.querySelector('[data-alpl-promo]');
  if (!banner) return;
  const code = banner.dataset.alplPromo;
  const pct = Number((banner.dataset.alplPromoLabel || '').match(/(\d+(?:[.,]\d+)?)\s*%/)?.[1]?.replace(',', '.'));
  const end = Date.parse(banner.dataset.alplPromoEnd || '');
  const live = () => !end || Date.now() < end;
  if (!code || !live()) return;
  const saleName = (banner.querySelector('.announcement-countdown__text')?.textContent || '').split('·')[0].trim() || 'Aktion';
  const gifts = (banner.dataset.alplGifts || '')
    .split(',')
    .map((g) => g.split(':'))
    .filter((g) => g.length >= 2 && Number(g[0]) > 0)
    .map(([min, ...rest]) => {
      const [name, variant] = rest.join(':').split('#');
      return { min: Number(min) * 100, name: name.trim(), variant: (variant || '').trim(), tier: name.includes('%') };
    })
    .sort((a, b) => a.min - b.min);

  const css = document.createElement('style');
  css.textContent = `.alpl-cart-promo{display:flex;align-items:center;justify-content:space-between;gap:10px;margin:0 0 8px;padding:7px 12px;background:#EFEBE3;font-size:12px;line-height:1.35}
.alpl-cart-gifts{margin:0 0 8px;padding:8px 12px;background:#EFEBE3;font-size:12px;line-height:1.35}
.alpl-cart-gifts__bar{height:4px;margin:6px 0 4px;background:rgba(0,0,0,.1);border-radius:2px;overflow:hidden}
.alpl-cart-gifts__bar span{display:block;height:100%;background:#1E2733;transition:width .3s}
.alpl-cart-gifts__got{font-size:11px;opacity:.75}
.alpl-pdp__gifts{display:block;margin-top:6px;font-size:.92em;opacity:.85}
.alpl-cart-promo button{flex:0 0 auto;padding:8px 16px;border:1px solid currentColor;background:transparent;font:inherit;font-size:11px;letter-spacing:.16em;text-transform:uppercase;cursor:pointer;color:inherit}`;
  document.head.append(css);

  const root = window.Shopify?.routes?.root || '/';
  let cartCodes = null;
  let cartTotal = 0;
  let cartItems = [];
  let codeEntered = false;
  let cartSaved = 0;

  const loadCodes = async () => {
    try {
      const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      // Geschenk-Schwellen zählen den Warenwert zum Originalpreis (vor Code und Mengenrabatt)
      cartTotal = Number(cart.original_total_price ?? cart.total_price) || 0;
      cartItems = cart.items || [];
      cartCodes = (cart.discount_codes || []).filter((d) => d.applicable !== false).map((d) => String(d.code).toUpperCase());
      // eingegeben, aber vom besseren Mengenrabatt verdrängt: kein „Einlösen“ mehr anbieten
      codeEntered = (cart.discount_codes || []).some((d) => String(d.code).toUpperCase() === code.toUpperCase());
      cartSaved = cart.original_total_price ? Math.round((1 - cart.total_price / cart.original_total_price) * 100) : 0;
    } catch (e) {
      cartCodes = [];
    }
    return cartCodes;
  };
  const hasCode = () => (cartCodes || []).includes(code.toUpperCase());

  const money = (cents) => {
    const fmt = document.querySelector('alpl-pdp')?.dataset.moneyFormat;
    const v = (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return fmt && fmt.includes('{{') ? fmt.replace(/\{\{\s*\w+\s*\}\}/, v) : `€ ${v}`;
  };

  /* Selbst verwaltete Geschenke: ab Schwelle beilegen, darunter wieder entfernen.
     Gleicher Weg wie alpl-pdp.js#addLines, damit Zähler und Drawer neu rendern. */
  let syncing = false;
  const syncGifts = async () => {
    const managed = gifts.filter((g) => g.variant);
    if (syncing || !managed.length || !live()) return;
    const updates = {};
    managed.forEach((g) => {
      const qty = cartItems.filter((i) => String(i.variant_id) === g.variant).reduce((n, i) => n + i.quantity, 0);
      const want = cartTotal >= g.min && cartItems.some((i) => !managed.some((m) => String(i.variant_id) === m.variant)) ? 1 : 0;
      if (qty !== want) updates[g.variant] = want;
    });
    if (!Object.keys(updates).length) return;
    syncing = true;
    try {
      const sectionIds = [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
      let Ev = null;
      let deferred = null;
      try {
        Ev = (await import('@shopify/events')).CartLinesUpdateEvent;
        deferred = Ev.createPromise();
        document.body.dispatchEvent(
          new Ev({
            action: 'add',
            context: 'product',
            lines: Object.entries(updates).map(([id, quantity]) => ({ merchandiseId: id, quantity })),
            promise: deferred.promise,
          })
        );
      } catch (e) {
        console.warn('[alpl-promo] Warenkorb-Event', e);
        deferred = null;
      }
      const res = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          updates,
          ...(sectionIds.length ? { sections: sectionIds.join(','), sections_url: location.pathname } : {}),
        }),
      }).then((r) => r.json());
      if (deferred) {
        deferred.resolve({
          cart: Ev.createCartFromAjaxResponse ? Ev.createCartFromAjaxResponse(res) : res,
          detail: { items: res.items, sections: res.sections, source: 'alpl-promo', itemCount: 1, didError: false },
        });
      } else if (location.pathname.endsWith('/cart')) {
        location.reload();
      }
    } catch (e) {
      console.warn('[alpl-promo] Geschenk', e);
    } finally {
      await loadCodes();
      syncing = false;
      renderGifts();
    }
  };

  /* EasyGift legt Zugaben nach der eigentlichen Änderung bei, ohne den Drawer neu zu rendern.
     Weichen die Zeilen im DOM vom Warenkorb ab, die Warenkorb-Sections einmal frisch holen. */
  let redrawing = false;
  const redrawCart = async () => {
    const comps = [...document.querySelectorAll('cart-items-component')].filter((el) => el.dataset.sectionId);
    if (redrawing || syncing || !comps.length) return;
    const domKeys = [...document.querySelectorAll('cart-items-component [data-key]')].map((r) => r.dataset.key);
    const cartKeys = cartItems.map((i) => i.key);
    const shown = new Set(domKeys);
    if (cartKeys.length === shown.size && cartKeys.every((k) => shown.has(k))) return;
    redrawing = true;
    try {
      const { morphSection } = await import('@theme/section-renderer');
      const ids = [...new Set(comps.map((el) => el.dataset.sectionId))];
      const sections = await fetch(`${location.pathname}?sections=${ids.join(',')}`).then((r) => r.json());
      // gleicher Modus wie component-cart-items.js
      comps.forEach((el) => {
        const id = el.dataset.sectionId;
        if (sections[id]) morphSection(id, sections[id], { mode: el.isDrawer ? 'hydration' : 'full' });
      });
    } catch (e) {
      console.warn('[alpl-promo] Warenkorb neu laden', e);
    } finally {
      redrawing = false;
    }
  };

  /* Produktseite */
  const renderPdp = () => {
    const slot = document.querySelector('[data-alpl-promo-slot]');
    const pdp = slot?.closest('alpl-pdp');
    const price = Number(pdp?.dataset.price);
    if (!slot || !price || !pct) return;
    const promo = Math.round(price * (1 - pct / 100));
    slot.hidden = false;
    const giftLine = gifts.length
      ? `<span class="alpl-pdp__gifts">${gifts.every((g) => g.tier) ? 'Ab ' : 'Gratis dazu: ab '}${gifts.map((g, i) => `${i ? 'ab ' : ''}${money(g.min).replace(',00', '')} ${i && !g.tier ? '+ ' : ''}${g.tier ? `sogar ${g.name} auf alles` : g.name}`).join(' · ')}</span>`
      : '';
    slot.innerHTML = (hasCode()
      ? `<span class="alpl-pdp__promo-ok">✓ Code <strong>${code}</strong> ist aktiv: ${money(promo)} statt ${money(price)} je Flasche bei Einmalkauf.</span>`
      : `<span>Mit Code <strong>${code}</strong>: <strong>${money(promo)}</strong> statt ${money(price)} (Einmalkauf)</span>
         <button type="button" data-alpl-promo-apply>Code anwenden</button>`) + giftLine;
  };

  const applyCode = async () => {
    await loadCodes();
    if (hasCode()) return;
    const codes = [...cartCodes, code];
    try {
      await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: codes.join(',') }),
      });
    } catch (e) {}
    await loadCodes();
    renderPdp();
    renderCart();
  };

  /* Warenkorb (Drawer und Seite): Button vor dem Feld „Rabatt“; nutzt das vorhandene Formular,
     damit der Warenkorb wie bei manueller Eingabe neu gerendert wird. */
  // Code eingegeben, aber Shopify nimmt den besseren Mengenpreis: erklären statt „nicht anwendbar“ stehen lassen
  const betterPrice = () => codeEntered && !hasCode() && cartSaved > pct;
  const priceNote = () => `${gifts.some((g) => g.tier && cartTotal >= g.min) ? 'Bestpreis' : 'Mengenpreis'} −${cartSaved} % statt ${pct} %`;

  // Eine schmale Box für Staffel und Preis-Hinweis (mobil zählt jede Zeile über „Zur Kasse“)
  const giftsHtml = () => {
    const got = gifts.filter((g) => cartTotal >= g.min);
    const next = gifts.find((g) => cartTotal < g.min);
    const prev = got.length ? got[got.length - 1].min : 0;
    const width = next ? Math.max(4, Math.round(((cartTotal - prev) / (next.min - prev)) * 100)) : 100;
    const last = gifts[gifts.length - 1];
    const head = next
      ? `Noch <strong>${money(next.min - cartTotal)}</strong> bis <strong>${next.name}</strong> ${next.tier ? 'auf alles' : 'gratis'}`
      : last.tier
        ? `<strong>✓ ${last.name} auf alles aktiv</strong>`
        : `<strong>Alle ${gifts.length} Geschenke gesichert</strong>`;
    const notes = [got.length && next ? `✓ ${got.length === 1 ? got[0].name : `${got.length} Geschenke`} dabei` : '', betterPrice() && next ? priceNote() : '']
      .filter(Boolean)
      .join(' · ');
    return `${head}<div class="alpl-cart-gifts__bar"><span style="width:${width}%"></span></div>${notes ? `<div class="alpl-cart-gifts__got">${notes}</div>` : ''}`;
  };

  const renderGifts = () => {
    if (!gifts.length) return;
    document.querySelectorAll('cart-discount-component').forEach((comp) => {
      const details = comp.closest('details') || comp;
      let box = details.parentElement.querySelector(':scope > .alpl-cart-gifts');
      if (!box) {
        box = document.createElement('div');
        box.className = 'alpl-cart-gifts';
        const promo = details.parentElement.querySelector(':scope > .alpl-cart-promo');
        (promo || details).before(box);
      }
      const html = giftsHtml();
      if (box.dataset.html !== html) {
        box.innerHTML = html;
        box.dataset.html = html;
      }
    });
  };

  const renderCart = () => {
    renderGifts();
    document.querySelectorAll('cart-discount-component').forEach((comp) => {
      const details = comp.closest('details') || comp;
      let box = details.parentElement.querySelector(':scope > .alpl-cart-promo');
      const better = betterPrice();
      // mit Geschenk-Staffel steht der Hinweis in deren Box
      if (hasCode() || codeEntered && !better || better && gifts.length) {
        box?.remove();
        return;
      }
      if (better) {
        const html = `<span>✓ ${priceNote()}</span>`;
        if (box && !box.classList.contains('alpl-cart-promo--info')) box.remove();
        box = details.parentElement.querySelector(':scope > .alpl-cart-promo--info');
        if (!box) {
          box = document.createElement('div');
          box.className = 'alpl-cart-promo alpl-cart-promo--info';
          details.before(box);
        }
        if (box.dataset.html !== html) {
          box.innerHTML = html;
          box.dataset.html = html;
        }
        return;
      }
      if (box?.classList.contains('alpl-cart-promo--info')) box.remove();
      else if (box) return;
      box = document.createElement('div');
      box.className = 'alpl-cart-promo';
      box.innerHTML = `<span>${saleName}: ${pct ? `${pct} % ` : ''}mit Code <strong>${code}</strong></span><button type="button">Einlösen</button>`;
      box.querySelector('button').addEventListener('click', (e) => {
        e.currentTarget.disabled = true;
        // Formular erst beim Klick suchen: der Warenkorb wird neu gerendert, alte Knoten sind dann abgehängt
        const live = box.nextElementSibling?.querySelector?.('cart-discount-component') || document.querySelector('cart-discount-component');
        const input = live?.querySelector('input[name="discount"]');
        if (!input?.form || !input.isConnected) return applyCode().then(() => location.pathname.endsWith('/cart') && location.reload());
        const details = input.closest('details');
        if (details) details.open = true;
        input.value = code;
        input.form.requestSubmit();
        refresh();
      });
      details.before(box);
    });
  };

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-alpl-promo-apply]');
    if (!b) return;
    b.disabled = true;
    applyCode();
  });

  // Warenkorb-Drawer wird bei jeder Änderung neu gerendert → Button wieder einsetzen (ohne Netzwerk;
  // der Countdown im Banner ändert das DOM jede Sekunde)
  let t;
  new MutationObserver(() => {
    clearTimeout(t);
    t = setTimeout(() => {
      if (cartCodes) renderCart();
    }, 200);
  }).observe(document.body, { childList: true, subtree: true });
  // Codes neu laden, wenn sich Warenkorb oder Rabatt ändern
  const update = () => loadCodes().then(() => { renderCart(); renderPdp(); return syncGifts(); }).then(redrawCart);
  // zweiter Durchlauf: EasyGift ändert den Warenkorb erst nach der Theme-Anfrage
  let t2;
  const refresh = () => {
    setTimeout(update, 400);
    clearTimeout(t2);
    t2 = setTimeout(update, 2000);
  };
  ['shopify:cart:lines-update', 'shopify:cart:discount-update', 'alpl:cart-updated'].forEach((n) => document.addEventListener(n, refresh));

  loadCodes().then(() => {
    renderPdp();
    renderCart();
    syncGifts();
  });
})();
